import { render, staticRenderFns } from "./LeagueDetailCard.vue?vue&type=template&id=382f676c&scoped=true&"
import script from "./LeagueDetailCard.vue?vue&type=script&lang=js&"
export * from "./LeagueDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./LeagueDetailCard.vue?vue&type=style&index=0&id=382f676c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382f676c",
  null
  
)

export default component.exports